import { h } from "preact";

import Icon from "./Icon.jsx";
import { classNames } from "../helpers.js";

export default function InfoLine({ iconVariant, text }) {
  let icon = <Icon class="info-line__icon">info_new</Icon>;
  if (iconVariant === "warning") {
    icon = (
      <Icon class="info-line__icon info-line__icon--warning">warning</Icon>
    );
  }
  return (
    <div class="info-line mb-48">
      {icon}
      <span class="t-caption">{text}</span>
    </div>
  );
}
